import React from 'react';

import renderWithStore from 'state/renderWithStore';
import RecommendedItemsSort from 'features/recommendedItems/components/RecommendedItemsSort';

// Resolve Safari issue when loading via browser back button
window.onpageshow = function (event) {

	if (event.persisted) {

		window.location.reload();

	}

};
const app = document.getElementById('appRecommendedItemsRecentlyViewed');

function onWidgetLoad (widget: any) {

	app.setAttribute('data-decisionId', widget?.DecisionId);

	if (!widget.Products || widget.Products.length < 1) {

		const fullPageEmptyContent = document.querySelector('.fullPageEmptyContent');
		if (fullPageEmptyContent) {

			fullPageEmptyContent.classList.remove('hidden');
			app.classList.add('hidden');

		}

	}

}

function App () {

	const productSortItemDisplayOptions: LP.sort.ProductSortItemDisplayOptions = {
		showAddToCart: true,
		showMoreLikeThis: false,
		showSaleCallout: false,
		showSavePrice: false,
		showShippingCallout: false
	};

	return (
		<RecommendedItemsSort
			schemeName="GF_full_rr"
			skeletonCount={3}
			onLoad={onWidgetLoad}
			productSortItemDisplayOptions={productSortItemDisplayOptions}
		/>
	);

}

renderWithStore(<App />, app);
